import { Button } from "reactstrap";
import { TipoHistoricoOrdemServicoEnum } from "services/OrdemServicoService";
import { formatDateTime } from "services/Utils";

export default function Registro({ item, onClickDetalhes }) {
  return (
    <div className="border p-2 rounded registro">
      <div className="d-flex justify-content-between">
        <div className="font-weight-bold">{item.usuario}</div>
        <div>{item.dataFmt}</div>
      </div>
      <div className="mt-2 d-flex justify-content-between">
        <div>{item.descricao}</div>
        <div>
          {(item.tipoHistorico == TipoHistoricoOrdemServicoEnum.MOVIMENTACAO || item.tipoHistorico == TipoHistoricoOrdemServicoEnum.FISCALIZACAO || item.tipoHistorico == TipoHistoricoOrdemServicoEnum.CORRECAO) && (
            <Button size="sm" color="primary" outline onClick={onClickDetalhes}>Detalhes</Button>
          )}
        </div>
      </div>
    </div>
  )
}